










import { Vue, Component, Prop } from 'vue-property-decorator';
import { ProductListBlockViewModel } from '@/types/contentServerContract';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import CondensedProductList from '@/project/product/condensed/CondensedProductList.vue';
import { ProductTileViewObject } from '@/types/apiServerContract';
import Api from '@/project/http/Api.service';

@Component({
    components: { SmartHeadline, CondensedProductList }
})
export default class ProductListBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: ProductListBlockViewModel;

    @Prop({
        required: false,
        type: Boolean,
        default: false
    }) isFirstBlock!: boolean;

    products: ProductTileViewObject[] = [];
    loading: boolean = false;

    async getProducts() {
        if (this.content.productIds.length === 0) return;

        this.loading = true;

        try {
            const result = await Api.product.simpleByItemId(this.content.productIds);
            this.products = result.products;
        } finally {
            this.loading = false;
        }
    }

    created() {
        this.getProducts();
    }
}
